// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bwZLm","name":"styles_name__3_Yir","phone":"styles_phone__2Uqb9"};